import React, { useEffect } from 'react';

type Props = {
  children: JSX.Element | JSX.Element[] | string;
  onCancel?: () => void;
  className?: string;
  backdropClose: boolean;
};

export enum DialogTypes {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export const Title = (props: { children: JSX.Element | JSX.Element[] | string; }): JSX.Element => {
  return <div className="dialog-title">{props.children}</div>;
};

export const Content = (props: { children: JSX.Element | JSX.Element[] | string; className?: string; }): JSX.Element => {
  return <div className={`dialog-content ${props.className || ''}`}>{props.children}</div>;
};

export const Actions = (props: { children: JSX.Element | JSX.Element[] | string; }): JSX.Element => {
  return <div className="dialog-actions">{props.children}</div>;
};

export const Dialog = (props: Props): JSX.Element => {
  return <DialogOverlay onClick={props.onCancel} backdropClose={props.backdropClose} className={props.className}>{props.children}</DialogOverlay>;
};

const DialogOverlay = (props: {
  children: JSX.Element | JSX.Element[] | string;
  onClick?: () => void;
  className?: string;
  backdropClose: boolean;
}): JSX.Element => {
  const onKeyUp = (event: KeyboardEvent): void => {
    if (event.key === 'Escape') {
      props.onClick?.();
    }
  };

  useEffect(() => {
    window.addEventListener('keyup', onKeyUp);
    return (): void => {
      window.removeEventListener('keyup', onKeyUp);
    };
  }, []);

  return (
    <div className="dialog-overlay" onClick={props.backdropClose? props.onClick: undefined} tabIndex={0}>
      <div className={`dialog-content-wrapper ${props.className || ''}`} onClick={(event): void => event.stopPropagation()}>
        {props.children}
      </div>
    </div>
  );
};
